"use client";

import { tokenAddresses } from "#/config/web3/tokens";
import { useReadTokenBalance } from "#/services/blockchain/blockchain.hooks";
import { useAccount } from "#/store/wallet/account/account";

import { useChainId } from "./useChainId";

export const useUsdcBalance = () => {
  const { chainId } = useChainId();
  const { account } = useAccount();

  const { data: usdcBalance, ...rest } = useReadTokenBalance(
    account,
    tokenAddresses.USDC[chainId],
    chainId,
  );

  return {
    usdcBalance,
    ...rest,
  };
};
